import React from 'react';
import PropTypes from 'prop-types';

function IconHome({ size = 20, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.33342 16.3329V12.1663H11.6667V16.3329C11.6667 16.7913 12.0417 17.1663 12.5001 17.1663H15.0001C15.4584 17.1663 15.8334 16.7913 15.8334 16.3329V10.4996H17.2501C17.6334 10.4996 17.8167 10.0246 17.5251 9.77461L10.5584 3.49961C10.2417 3.21628 9.75841 3.21628 9.44175 3.49961L2.47508 9.77461C2.19175 10.0246 2.36675 10.4996 2.75008 10.4996H4.16675V16.3329C4.16675 16.7913 4.54175 17.1663 5.00008 17.1663H7.50008C7.95842 17.1663 8.33342 16.7913 8.33342 16.3329Z" fill="white"/>
    </svg>
  )
}

IconHome.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconHome;
